import { useElectronPrintersActions } from '@store/actions/electronPrinters';
import { useEffect } from 'react';
import { useElectron } from './useElectron';
import toast from 'react-hot-toast';
import { ElectronPrinter } from '@interfaces/general';
import { capturePrintError } from '@utils/print/printSentry';

// Refresca la lista de impresoras detectadas (IPC getPrinters) SIN efecto de
// montaje. Úsalo para el botón "Actualizar lista" sin disparar un fetch
// redundante (la inicialización global vive en Layout vía useInitElectronPrinters).
export const useRefreshElectronPrinters = () => {
  const { initElectronPrinters } = useElectronPrintersActions();
  const { isElectronInstance, ipcRenderer } = useElectron();

  return async () => {
    if (!isElectronInstance) return;
    try {
      const printers: ElectronPrinter[] = await ipcRenderer.invoke('getPrinters');
      initElectronPrinters(printers);
    } catch (error) {
      // El shell Electron desactualizado no expone el IPC getPrinters → se distingue del
      // resto de fallos de IPC para poder correlacionar por versión/plataforma del shell.
      const isHandlerMissing = error?.toString().includes('No handler registered');
      capturePrintError(error, {
        tag: isHandlerMissing ? 'getPrinters_no_handler' : 'print_ipc_failure',
        trigger: 'init',
      });
      toast.error('Error al leer las impresoras instaladas');
    }
  };
};

// Inicialización global (una sola vez, en Layout): detecta impresoras al montar.
export const useInitElectronPrinters = () => {
  const { isElectronInstance } = useElectron();
  const refreshPrinters = useRefreshElectronPrinters();

  useEffect(() => {
    if (isElectronInstance) {
      refreshPrinters();
    }
  }, [isElectronInstance]);
};
